<div [formGroup]="formGroup" *ngIf="formInitialized$ | async; else loading">

	<div class="settings-container">
		<div class="setting-description">
			<label class="form-label">{{ 'AL.MAIL_LOGS' | translate: locale.language }}</label>
		</div>
		<div class="setting-field">
			<dx-switch class="al-switch" as-validator formControlName="mailLogs"></dx-switch>
		</div>
	</div>
	<div class="settings-container">
		<div class="setting-description">
			<label class="form-label">{{ 'AL.MAIL_ADDRESS' | translate: locale.language }}</label>
		</div>
		<div class="setting-field">
			<dx-text-box as-validator formControlName="mailAddress" class="form-control"></dx-text-box>
		</div>
	</div>
</div>
<ng-template #loading>
	Loading...
</ng-template>
